import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { isNullOrUndefined } from 'shared/utils/null.utils';
import { IVirtualTableColumn } from 'components/layout/VirtualTable/Table/components/VirtualTable';
import { VirtualTable } from 'components/layout/VirtualTable/Table';
import { Issue } from '../../../queries/issues-list.queries.types';
import { StyledNoResults } from '../styled/IssueListTable.styled';
import { viewAmmendIssueRoute } from '../../../../../routes/issues-management.routes';
import { getIssueListTableColumns } from '../utils/getIssueListTableColumns';
import { CopyListAndSort } from 'shared/utils/sorting.utils';
import { getConcernLevelNumericValue } from 'shared/utils/concern-level.utils';

interface IssueTableProps {
   data?: Issue[];
}

const IssuesListTable = ({ data = [] }: IssueTableProps) => {
   const history = useHistory();

   const displayDataRef = useRef<Issue[]>([]);
   const [displayData, setDisplayData] = useState<Issue[]>([]);
   const [displayColumns, setDisplayColumns] = useState<IVirtualTableColumn<Issue>[]>(prepairTableColumns());

   function prepairTableColumns(): IVirtualTableColumn<Issue>[] {
      let columns = getIssueListTableColumns(handleColumnClick, handleRowClick);
      columns.forEach((column: IVirtualTableColumn<Issue>) => {
         column.name = column.name;
      });
      return columns;
   }

   useEffect(() => {
      setDisplayData(
         data.sort((a: Issue, b: Issue) => {
            const sortValueA = a.incidentDate;
            const sortValueB = b.incidentDate;

            return (true ? sortValueA < sortValueB : sortValueA > sortValueB) ? 1 : -1;
         })
      );
      displayDataRef.current = data;
   }, [data]);

   useEffect(() => {
      let newColumns = prepairTableColumns();
      setDisplayColumns(newColumns);
   }, []);

   function handleColumnClick(ev: React.MouseEvent<HTMLElement>, column: IVirtualTableColumn<Issue>): void {
      const newColumns: IVirtualTableColumn<Issue>[] = [...displayColumns];

      const selectedColumn: IVirtualTableColumn<Issue> = newColumns.filter(currCol => column.key === currCol.key)[0];

      newColumns.forEach((column: IVirtualTableColumn<Issue>) => {
         if (column === selectedColumn) {
            selectedColumn.isSortedDescending = !selectedColumn.isSortedDescending;
            selectedColumn.isSorted = true;
         } else {
            column.isSorted = false;
         }
      });

      let newList: Issue[] = [];

      if (selectedColumn.fieldName == 'concernLevel') {
         newList = SortByConcernlevel(displayDataRef.current, selectedColumn.isSortedDescending);
      } else {
         newList = CopyListAndSort(
            displayDataRef.current,
            selectedColumn.fieldName!,
            selectedColumn.isSortedDescending,
            selectedColumn.sortValueResolver
         );
      }

      setDisplayColumns(newColumns);
      setDisplayData(newList);
   }

   const SortByConcernlevel = (list: Issue[], isSortedDescending: boolean | undefined): Issue[] => {
      return list.sort((a: Issue, b: Issue) => {
         const sortValueA = getConcernLevelNumericValue(a.concernLevel);
         const sortValueB = getConcernLevelNumericValue(b.concernLevel);

         return (isSortedDescending ? sortValueA < sortValueB : sortValueA > sortValueB) ? 1 : -1;
      });
   };

   function handleRowClick(item: Issue) {
      history.push(viewAmmendIssueRoute(item.observationId.toString()));
   }

   return (
      <React.Fragment>
         {(isNullOrUndefined(data) || data.length === 0) && (
            <StyledNoResults>No records found for the currently selected filters</StyledNoResults>
         )}

         {!isNullOrUndefined(data) && data.length > 0 && (
            <VirtualTable<Issue>
               columns={displayColumns}
               items={displayData}
               onRowClick={item => history.push(viewAmmendIssueRoute(item?.observationId.toString()))}
               keyFieldName='observationId'
            />
         )}
      </React.Fragment>
   );
};

export default IssuesListTable;
